import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { loadTeachers } from '../../actions/userActions';
import { GFClass, GFInitialState, GFTeacherUser } from '../../models/models';

type Props = {
  teacher: GFTeacherUser|undefined;
  classes: GFClass[];
}

const Footer: React.FC<Props> = ({ teacher, classes }) => {
  const isPreTestsOptional = (): boolean => {
    if (teacher) {
      return !! teacher.classes.find(c => c.preTestsOptional);
    }

    return !! classes.find(c => c.preTestsOptional)
  }

  if (! isPreTestsOptional()) {
    return null;
  }

  return <Row className="students-header">
    <Col md={10} xs={10} className="text-xl-left">
      <p style={{padding: '25px 0', fontStyle: 'italic'}}>
        * Teacher elected to make pre-tests optional;
        therefore, student scores may not reflect the greatest possible growth from pre-test to post-evaluation.
      </p>
    </Col>
  </Row>;
};

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  return {
    classes: state.classes,
  };
};

export default connect(mapStateToProps, {
  loadTeachers,
})(Footer);
